import React, { useRef, useEffect } from 'react';

const colors = ["#e03776", "#8f3e98", "#4687bf", "#3bab6f", "#f9c25e", "#f47274"];
const NUM_HEARTS = 16;

import '../_styles.scss';

export const Hearts: React.FC = () => {
  const heartsRef = useRef<(SVGUseElement & { n: number })[]>([]);
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const svg = svgRef.current;
    // Initialize hearts array
    if (svg && heartsRef.current.length === 0) {
      for (let n = NUM_HEARTS - 1; n >= 0; n--) {
        const use = document.createElementNS('http://www.w3.org/2000/svg', 'use') as SVGUseElement & { n: number };
        use.n = n;
        use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#heart');
        use.setAttribute('transform', `scale(${use.n})`);
        use.setAttribute('fill', colors[n % colors.length]);
        use.setAttribute('x', '-69');
        use.setAttribute('y', '-69');
        use.setAttribute('width', '138');
        use.setAttribute('height', '138');
        heartsRef.current.push(use);
        svg.appendChild(use);
      }
    }

    let animationFrameId: number;
    let lastFrameTime = 0;
    const targetFPS = 20;
    const frameInterval = 1000 / targetFPS;

    const animate = (timestamp: number) => {
      // Throttle to target FPS
      const elapsed = timestamp - lastFrameTime;
      
      if (elapsed < frameInterval) {
        animationFrameId = window.requestAnimationFrame(animate);
        return;
      }
      
      lastFrameTime = timestamp - (elapsed % frameInterval);

      for (let i = 0; i < heartsRef.current.length; i++) {
        if (heartsRef.current[i].n < NUM_HEARTS - 1) {
          heartsRef.current[i].n += 0.03;
        } else {
          heartsRef.current[i].n = 0;
          svg?.appendChild(heartsRef.current[i]);
        }
        heartsRef.current[i].setAttribute('transform', `scale(${heartsRef.current[i].n})`);
      }
      animationFrameId = window.requestAnimationFrame(animate);
    };

    // Pause animation when tab is not visible
    const handleVisibilityChange = () => {
      if (document.hidden) {
        if (animationFrameId) {
          window.cancelAnimationFrame(animationFrameId);
        }
      } else {
        animationFrameId = window.requestAnimationFrame(animate);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    animationFrameId = window.requestAnimationFrame(animate);

    return () => {
      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      // Clean up SVG children
      if (svg) {
        heartsRef.current.forEach(use => {
          svg.removeChild(use);
        });
        heartsRef.current = [];
      }
    };
  }, []);

  return (
    <svg
      id="hearts"
      ref={svgRef}
      viewBox="-600 -400 1200 800"
      preserveAspectRatio="xMidYMid slice"
      style={{ width: '100vw', height: '100vh', display: 'block', overflow: 'hidden', zIndex: -10 }}
    >
      <defs>
        <symbol id="heart" viewBox="-69 -16 138 138">
          <path d="M0,12 C 50,-30 110,50  0,120 C-110,50 -50,-30 0,12z" />
        </symbol>
      </defs>
      {/* Hearts are appended via JS */}
    </svg>
  );
};

export default Hearts;
